/**
 * Minimum number of digits for a query to be treated as a phone-number
 * search. Below this, digits-only input is more likely a reference ID.
 */
export const MIN_PHONE_SEARCH_DIGITS = 7;

/**
 * Normalizes a users-search query for phone-number lookups (#108).
 *
 * The backend indexes phone numbers with their leading '+' and matches by
 * prefix, so a digits-only query like `4917643375180` never matches while
 * `+4917643375180` does. When the input is digits-only (after stripping
 * spaces and dashes) and long enough to plausibly be an international
 * number, send the '+'-prefixed variant instead. Names, emails, and IDs are
 * left untouched.
 */
export const normalizeSearchKeywords = (keywords: string): string => {
  const compact = keywords.trim().replace(/[\s-]/g, '');
  const digitsOnlyPattern = new RegExp(`^\\d{${MIN_PHONE_SEARCH_DIGITS},}$`);

  return digitsOnlyPattern.test(compact) ? `+${compact}` : keywords;
};
